import config from "../../../config/config";

/** Backend paths from `APP_CONFIG.API_ROUTES` (mounted in backend/index.js). */
export const VISITOR_API_ROUTES = {
  visitors: `${config.BASE_URL}/visitors`,
  visitorPurpose: `${config.BASE_URL}/visitor-purpose`,
  visitorIdProof: `${config.BASE_URL}/visitor-id-proof`,
  staffSearch: `${config.BASE_URL}/visitors/staff/search`,
};

/** App paths under `/app` (registered in screenRegistry). */
export const VISITOR_APP_PATHS = {
  dashboard: "visitors/dashboard",
  list: "visitors",
  create: "visitors/new",
  edit: (id) => `visitors/${id}/edit`,
  details: (id) => `visitors/${id}`,
  purposes: "visitors/purposes",
  purposeCreate: "visitors/purposes/new",
  idProof: "visitors/id-proof",
  idProofCreate: "visitors/id-proof/new",
};
